import React from "react"
import { Dropdown, DropdownToggle, DropdownMenu } from "reactstrap"
import "./UserNav.scss"
import PropTypes from "prop-types"

class UserNav extends React.Component {
  constructor(props) {
    super(props)

    this.toggle = this.toggle.bind(this)
    this.state = {
      dropdownOpen: false,
    }
  }

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    })
  }

  render() {
    const links = [
      ...this.props.applications,
      {
        text: "Change Password",
        url: process.env.REACT_APP_AUTH_DOMAIN + "/users/settings",
      },
      {
        text: "Log Out",
        url: process.env.REACT_APP_AUTH_DOMAIN + "/users/sign_out",
      },
    ]

    const ItemLink = ({ url, text, target }) => {
      const sharedProps = {
        className: "dropdown-item",
        onClick: this.toggle,
        target,
      }

      return (
        <a eventLabel="menuNavigation" href={url} {...sharedProps}>
          {text}
        </a>
      )
    }

    return (
      <div className="UserNav">
        <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
          <DropdownToggle
            className="DropdownToggle"
            onClick={() => this.toggle()}
          >
            {this.props.initials}
          </DropdownToggle>
          <DropdownMenu role="menuitem" right>
            {links.map(link => (
              <ItemLink key={link.url} {...link} />
            ))}
          </DropdownMenu>
        </Dropdown>
      </div>
    )
  }
}

UserNav.propTypes = {
  initials: PropTypes.string,
  applications: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    })
  ),
}

UserNav.defaultProps = {
  initials: "",
  applications: [],
}

export default UserNav
